import React from "react";
import useDarkMode from "../../../hooks/useDarkMode";
import useThemeColor from "../../../hooks/useThemeColor";
import CustomModal from "./customModal";

const DealSlotTypeSelectionModal = ({
  isOpen,
  onClose,
  onSelectType,
}) => {
  const themeColor = useThemeColor();
  const isDarkMode = useDarkMode();

  const handleSelect = (type) => {
    if (typeof onSelectType === "function") {
      onSelectType(type);
    }
    onClose();
  };

  return (
    <CustomModal
      title="Select Type"
      isOpen={isOpen}
      onClose={onClose}
      showButton={false}
      showSubmitButton={false}
      showCancelButton={false}
      isCentered={true}
      modalSize="modal-md"
    >
      <div style={{ padding: "10px 0" }}>
        <p
          style={{
            color: isDarkMode ? "#a0aec0" : "#718096",
            fontSize: "14px",
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          Choose whether you want to select Categories or Items for this slot.
        </p>

        <div className="row g-3">
          <div className="col-12 col-md-6">
            <button
              type="button"
              className="btn w-100"
              onClick={() => handleSelect("categories")}
              style={{
                background: `linear-gradient(135deg, #4299e1 0%, #3182ce 100%)`,
                border: "none",
                color: "white",
                borderRadius: "12px",
                padding: "24px 20px",
                fontSize: "16px",
                fontWeight: "600",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 12px rgba(66, 153, 225, 0.3)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
                minHeight: "140px",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 6px 20px rgba(66, 153, 225, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 12px rgba(66, 153, 225, 0.3)";
              }}
            >
              <i
                className="fa fa-tags"
                style={{ fontSize: "32px", opacity: "0.9" }}
              ></i>
              <span>Categories</span>
              <small style={{ opacity: "0.85", fontSize: "13px", fontWeight: "400" }}>
                Select from categories
              </small>
            </button>
          </div>

          <div className="col-12 col-md-6">
            <button
              type="button"
              className="btn w-100"
              onClick={() => handleSelect("items")}
              style={{
                background: `linear-gradient(135deg, #48bb78 0%, #38a169 100%)`,
                border: "none",
                color: "white",
                borderRadius: "12px",
                padding: "24px 20px",
                fontSize: "16px",
                fontWeight: "600",
                transition: "all 0.3s ease",
                boxShadow: "0 4px 12px rgba(72, 187, 120, 0.3)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
                minHeight: "140px",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-4px)";
                e.target.style.boxShadow = "0 6px 20px rgba(72, 187, 120, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 12px rgba(72, 187, 120, 0.3)";
              }}
            >
              <i
                className="fa fa-box"
                style={{ fontSize: "32px", opacity: "0.9" }}
              ></i>
              <span>Items</span>
              <small style={{ opacity: "0.85", fontSize: "13px", fontWeight: "400" }}>
                Select specific items
              </small>
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default DealSlotTypeSelectionModal;

